import React from "react";
import { Card } from "@/components/ui/card";
import { Gift } from "lucide-react";

export default function ReferTab() {
  return (
    <Card className="p-10 border-slate-200 text-center" data-testid="refer-tab">
      <div className="mx-auto h-14 w-14 rounded-2xl bg-indigo-50 flex items-center justify-center">
        <Gift className="h-7 w-7 text-indigo-600" />
      </div>
      <h2 className="font-display text-xl font-semibold mt-4">Refer a PG</h2>
      <span className="inline-block mt-2 text-[10px] font-semibold uppercase tracking-wider bg-amber-100 text-amber-700 px-2.5 py-1 rounded-full" data-testid="refer-coming-soon-badge">Coming soon</span>
      <p className="text-sm text-slate-500 mt-3 max-w-md mx-auto">
        Refer fellow PG, hostel or coliving owners to PGRentReceipts and earn rewards when they join. We're putting the finishing touches on this — stay tuned!
      </p>
    </Card>
  );
}
